module.exports = __webpack_public_path__ + "static/media/warehouse-solid.1a94cc38.svg";